<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Tramos</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="showAddModal = true">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Tramo</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
  
              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="query"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>

              <el-select
                class="select-primary pagination-select"
                v-model="status"
                placeholder="Seleccionar status"
                clearable
              >
                <el-option
                  class="select-primary"
                  label="Activo/Inactivo"
                  value="Activo/Inactivo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Activo"
                  value="Activo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Inactivo"
                  value="Inactivo"
                >
                </el-option>
              </el-select>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="tramos"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>

              <div slot="empty" v-if="tramos">
                Sin datos disponibles
              </div>
  
              <el-table-column label="Terminal Origen" prop="relationships.terminal_origen.nombre" />
              <el-table-column label="Terminal Destino" prop="relationships.terminal_destino.nombre" />
              <el-table-column label="Tiempo" prop="attributes.tiempo" />
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editTramo(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button v-if="row.attributes.active" class="hover-apolo" type="primary" icon size="sm" @click="deactivateTramo(row)">
                    <span class="btn-inner--text">Desactivar</span>
                  </base-button>
                  <base-button  v-else class="hover-apolo" type="primary" icon size="sm" @click="activateTramo(row)">
                    <span class="btn-inner--text">Activar</span>
                  </base-button>
                </div>
            </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border justify-content-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear tramo</h6>
        <form class="new-event--form" @submit.prevent="addTramo">
          <base-input label="Terminal de origen">
            <multiselect id="tramo_select_origen" v-model="tramo.terminal_origen" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione terminal de origen" label="nombre" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.terminal_origen_id" />
          <base-input label="Terminal de destino">
            <multiselect id="tramo_select_destino" v-model="tramo.terminal_destino" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione terminal de destino" label="nombre" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.terminal_destino_id" />
          <br>
          <span v-if="error != null">
            <small class="argon-error" v-text="error"/>
          </span>
          <base-input label="Tiempo"
                      placeholder="Tiempo en minutos"
                      v-model="tramo.tiempo"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.tiempo" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addTramo">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar tramo</h6>
        <form class="new-event--form" @submit.prevent="editTramo">
            <base-input label="Terminal de origen">
                <multiselect disabled v-model="tramo.terminal_origen" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione terminal de origen" label="nombre" track-by="id" :showLabels="false"></multiselect>
            </base-input>
            <validation-error :errors="apiValidationErrors.terminal_origen" />
            <base-input label="Terminal de destino">
                <multiselect disabled v-model="tramo.terminal_destino" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione terminal de destino" label="nombre" track-by="id" :showLabels="false"></multiselect>
            </base-input>
            <validation-error :errors="apiValidationErrors.terminal_destino" />
            <br>
            <span v-if="error != null">
              <small class="argon-error" v-text="error"/>
            </span>
            <base-input label="Tiempo"
                      placeholder="Tiempo en minutos"
                      v-model="tramo.tiempo"
                      input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.tiempo" />
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateTramo">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import ValidationError from "@/components/ValidationError.vue";
  import formMixin from "@/mixins/form-mixin";
  import Multiselect from 'vue-multiselect'
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      ValidationError,
      Multiselect,
      Modal,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        tramos: [],
        terminales: [],
        selectedRows: [],
        query: null,
        status: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 tramos por página'},
          {value:'10', descripcion: '10 tramos por página'},
          {value:'25', descripcion: '25 tramos por página'},
          {value:'50', descripcion: '50 tramos por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        tramo: {
          type: "tramos",
          tiempo: null,
          terminal_origen: null,
          terminal_destino: null
        },
        validation: null,
        error: null,
      };
    },

    mounted(){
      this.getTerminales();
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      query: {
        handler: "getListDebounced",
        immediate: true,
      },
      status: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },
  
    methods: {
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
            ...(this.status ? { status: this.status } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
  
        await this.$store.dispatch("tramos/list", params).then(() => {
          this.tramos = this.$store.getters["tramos/list"];
          this.total = this.$store.getters["tramos/listTotal"];
        });
        this.loading = false;
      },

      async getTerminales() {
        let params = {
          filter: {
          },
          page: {
            number: 1,
            size: 100000,
          },
        };
        await this.$store.dispatch("terminales/list", params).then(() => {
          this.terminales = this.$store.getters["terminales/list"];
        });
      },

      closeModal() {
        this.resetApiValidation();
        this.error = null;
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.tramo.tiempo = null;
        this.tramo.terminal_origen = null;
        this.tramo.terminal_destino = null;
      },
      validationFinal(){
        let existe = false;
        for(let i = 0; i < this.tramos.length; i++){
          if((Number(this.tramos[i].attributes.terminal_origen_id) === Number(this.tramo.terminal_origen.id)) && (Number(this.tramos[i].attributes.terminal_destino_id) === Number(this.tramo.terminal_destino.id))){
            existe = true;
            break;
          }
        }
        return existe;
      },
      async addTramo(){
        if(this.tramo.terminal_origen != null && this.tramo.terminal_destino != null){
          this.resetApiValidation();
          let validacion = this.validationFinal();
          if(validacion){
            this.error = 'Existe un tramo con el mismo origen y destino'
          }else{
            try {
            await this.$store.dispatch("tramos/add", this.tramo);

            this.$notify({
              type: "success",
              message: "Tramo creado satisfactoriamente.",
              duration: -1
            });
            this.error = null;
            this.getList();
            this.closeModal();
            } catch (error) {
              if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
              } else {
                  this.$notify({
                      type: "danger",
                      message: "Oops, ha ocurrido un problema!",
                      duration: -1
                  });
              }
              this.error = null;
              this.resetApiValidation();
              this.setApiValidation(error.response.data.errors);
            }
          }
        }else{
          try {
          await this.$store.dispatch("tramos/add", this.tramo);

          this.$notify({
            type: "success",
            message: "Tramo creado satisfactoriamente.",
            duration: -1
          });
          this.error = null;
          this.getList();
          this.closeModal();
          } catch (error) {
            if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: "Oops, ha ocurrido un problema!",
                    duration: -1
                });
            }
            this.error = null;
            this.resetApiValidation();
            this.setApiValidation(error.response.data.errors);
          }
        }
      },

      editTramo(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.tramo.tiempo = row.attributes.tiempo;
        this.tramo.terminal_origen = this.terminales.find(item => item.id == row.relationships.terminal_origen.id);
        this.tramo.terminal_destino = this.terminales.find(item => item.id == row.relationships.terminal_destino.id);
        this.tramo.id = row.id;
      },

      async updateTramo() {
        try{
          await this.$store.dispatch("tramos/update", this.tramo);
          this.$notify({
            type: "success",
            message: "Tramo actualizado satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      async activateTramo(row) {
        const confirmation = await swal.fire({
          title: `¿Desea activar este tramo?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Activar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("tramos/activate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Tramo activado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
      async deactivateTramo(row) {
        const confirmation = await swal.fire({
          title: `¿Desea desactivar este tramo?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Desactivar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("tramos/deactivate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Tramo desactivado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
  
      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>
  <style lang="scss">
   .argon-error {
     position: relative;
     bottom: 25px !important;
     color: #fb6340;
     }
  </style>